import React from 'react';
import {Input} from '../index';
import {useDispatch, useSelector} from 'react-redux';
import {useInput} from '../../model';
import {setMainLabel} from '../../service/createForm.slice';
import {useTranslation} from '../../../../hooks/useTranslation';

function FormName(props) {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const form_title = useInput('');

  const handleChange = e => {
    form_title.handleChange(e);
    dispatch(setMainLabel(e.target.value));
  };

  return (
    <Input
      value={props?.category?.label ? props?.category?.label : ''}
      onChange={handleChange}
      has_tooltip={props.readOnly ? false : true}
      is_form={true}
      label={t('createNewForm.components.inspectionFormsName')}
      placeholder={t('createNewForm.components.enterInspectionFormsName')}
      tooltipText={t('createNewForm.components.formNameTooltip')}
      disabled={props.readOnly ? true : false}
    />
  );
}

export default FormName;
